var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cargo Booking Settings")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Setting Variables")]), _vm._v(" "), _c('th', [_vm._v("Values")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Exempted HSN Codes")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list-ol'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.HSNCode),
      expression: "HSNCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|verify_hsncode'),
      expression: "'required|verify_hsncode'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HsnCode')
    },
    attrs: {
      "rows": 3,
      "id": "HsnCode",
      "name": "HsnCode",
      "placeholder": "Enter HSN Code"
    },
    domProps: {
      "value": (_vm.HSNCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.HSNCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("Note: Use Comma (,) for Multiple HSN Codes. Without Space.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HsnCode')),
      expression: "errors.has('HsnCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('HsnCode')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'hsncode')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("EBN 1 Lakh Limit States")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.StatesLimit,
      "name": "StatesLimit",
      "id": "StatesLimit",
      "placeholder": "Select states with 1 Lakh EBN limit ",
      "label": "statename",
      "track-by": "statename",
      "multiple": true,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.SelectedStates),
      callback: function($$v) {
        _vm.SelectedStates = $$v
      },
      expression: "SelectedStates"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'limitstate')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Print Sticker Select Options")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list-ol'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.printstickeroptions),
      expression: "printstickeroptions"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('printsticker')
    },
    attrs: {
      "rows": 3,
      "id": "printsticker",
      "name": "printsticker",
      "placeholder": "Enter Print Sticker Select Options"
    },
    domProps: {
      "value": (_vm.printstickeroptions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.printstickeroptions = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("Note: Use Key-Value pair object for multiple sticker options separated by comma (,) .")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('printsticker')),
      expression: "errors.has('printsticker')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('printsticker')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'printsticker')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_vm._v("Maximum Volumetric Weight Per MPS")]), _vm._v(" "), _c('p', [_vm._v("Maximum Volumetric Weight Per AWB")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MaxVolWt),
      expression: "MaxVolWt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('MaxVolWt')
    },
    attrs: {
      "type": "number",
      "id": "MaxVolWt",
      "name": "MaxVolWt",
      "placeholder": "Enter Weight in KG"
    },
    domProps: {
      "value": (_vm.MaxVolWt)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MaxVolWt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MaxVolWt')),
      expression: "errors.has('MaxVolWt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MaxVolWt')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MaxVolWtAWB),
      expression: "MaxVolWtAWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('MaxVolWtAWB')
    },
    attrs: {
      "type": "number",
      "id": "MaxVolWtAWB",
      "name": "MaxVolWtAWB",
      "placeholder": "Enter Weight in KG"
    },
    domProps: {
      "value": (_vm.MaxVolWtAWB)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MaxVolWtAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MaxVolWtAWB')),
      expression: "errors.has('MaxVolWtAWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MaxVolWtAWB')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'maxvolmpsawb')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_vm._v("Maximum Physical Weight Per MPS")]), _vm._v(" "), _c('p', [_vm._v("Maximum Physical Weight Per AWB")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MaxPhyWt),
      expression: "MaxPhyWt"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('MaxPhyWt')
    },
    attrs: {
      "type": "number",
      "id": "MaxPhyWt",
      "name": "MaxPhyWt",
      "placeholder": "Enter Weight in KG"
    },
    domProps: {
      "value": (_vm.MaxPhyWt)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MaxPhyWt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MaxPhyWt')),
      expression: "errors.has('MaxPhyWt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MaxPhyWt')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MaxPhyWtAWB),
      expression: "MaxPhyWtAWB"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('MaxPhyWtAWB')
    },
    attrs: {
      "type": "number",
      "id": "MaxPhyWtAWB",
      "name": "MaxPhyWtAWB",
      "placeholder": "Enter Weight in KG"
    },
    domProps: {
      "value": (_vm.MaxPhyWtAWB)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MaxPhyWtAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MaxPhyWtAWB')),
      expression: "errors.has('MaxPhyWtAWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MaxPhyWtAWB')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'maxphympsawb')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Origin Hubs")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "originhub",
      "placeholder": "Select Origin Hub",
      "label": "hubname",
      "track-by": "hubid",
      "multiple": true,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.originhubids),
      callback: function($$v) {
        _vm.originhubids = $$v
      },
      expression: "originhubids"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'originhubids')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Destination Hubs")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "destinationhub",
      "placeholder": "Select Destination Hub",
      "label": "hubname",
      "track-by": "hubid",
      "multiple": true,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.destinationhubids),
      callback: function($$v) {
        _vm.destinationhubids = $$v
      },
      expression: "destinationhubids"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('booking', 'destinationhubids')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa9c592","hasScoped":true}!./src/modules/adminsettings/views/configuration/cargobooking/cargobookingconfiguration.component.html
// module id = 2022
// module chunks = 3